import './Gym.css'
import BackHome from '../nav/BackHome'
function Gym () {
    return(
        <div className='gym'>
        <BackHome/>
            Gym
        </div>
    )
}
export default Gym;